import React, { useState, useEffect } from 'react';
import { InputTasa, InputSubTasa, InputNumber, InputEntidad, FormLabel, Modal, Select, FormError } from '../../common';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { useFormErrors } from '../../hooks/useFormErrors';
import { object, func } from 'prop-types';
import { CloneObject } from '../../../utils/helpers';
import { isValidNumber } from '../../../utils/validator';

import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import {PERMISSIONS} from "../../../consts/permissions";
import { usePermissions } from '../../hooks/usePermissions';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';

const CuentaDebitoCreditoModal = (props) => {

    const entityInit = {
        id: 0,
        idCuentaCorriente: 0,
        idEmisionEjecucion: null,
        idEmisionCuentaCorrienteResultado: null,
        idPlanPago: null,
        idPlanPagoCuota: null,
        idCertificadoApremio: null,
        idCuenta: null,
        idTasa: 0,
        idSubTasa: 0,
        periodo: "",
        cuota: 0,
        idRubro: 0,
        codigoDelegacion: "",
        idTipoMovimiento: 0,
        numeroMovimiento: "",
        tasaCabecera: false,
        idTipoValor: 0,
        importeDebe: 0,
        importeHaber: 0,
        idLugarPago: 0,
        fechaOrigen: null,
        fechaMovimiento: null,
        fechaVencimiento1: null,
        fechaVencimiento2: null,
        fechaVencimiento1Original: null,
        fechaVencimiento2Original: null,
        fechaVencimiento1Prorroga: null,
        fechaVencimiento2Prorroga: null,
        cantidad: 0,
        idEdesurCliente: null,
        detalle: "",
        item: 0,
        idUsuarioRegistro: null,
        fechaRegistro: null,
        idUsuarioProceso: 0,
        fechaProceso: null,
        fechaCobro: null,
        numeroPartidaOrigen: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        tasas: [],
        rubros: [],
        loading: false
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState,
                entity: props.data.entity,
                tasas: props.data.tasas,
                rubros: props.data.rubros
            };
        });
    }
    useEffect(mount, [props.data]);

    const { hasPermission } = usePermissions();
    const canEditDebitoCredito = hasPermission(PERMISSIONS.DEBITO_CREDITO_EDIT);

    const [ formValues, formHandle, , ] = useForm({
        imputacion: 0,
        detalle: '',
        idTasa: 0,
        idSubTasa: 0,
        idRubro: 0,
        importe: 0
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.detalle = formValues.detalle;
        row.idTasa = formValues.idTasa;
        row.idSubTasa = formValues.idSubTasa;
        row.idRubro = formValues.idRubro??0;
        if (formValues.imputacion === 1) {
            row.importeDebe = formValues.importe;
            row.importeHaber = 0;
        }
        else {
            row.importeDebe = 0;
            row.importeHaber = formValues.importe;
        }

        AddCuentaDebitoCredito(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.detalle.length <= 0) errors.detalle = VALIDATION_MESSAGE.REQUIRED;

        if (formValues.idTasa <= 0) errors.idTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        else if (formValues.imputacion === 2 && !state.tasas.map(x => x.idTasa).includes(formValues.idTasa)) errors.idTasa = 'No está incluida en la partida';

        if (formValues.idSubTasa <= 0) errors.idSubTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        else if (formValues.imputacion === 2 && !state.tasas.map(x => x.idSubTasa).includes(formValues.idSubTasa)) errors.idSubTasa = 'No está incluida en la partida';

        if (formValues.imputacion === 2 && !state.rubros.includes(formValues.idRubro)) errors.idRubro = 'No está incluido en la partida';

        if (formValues.imputacion <= 0) errors.imputacion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (!isValidNumber(formValues.importe, true)) errors.importe = 'Ingresá un número mayor a cero';

        return errors;
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessAddCuentaDebitoCredito = (response) => {
        response.json()
        .then((data) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "El ajuste fue ingresado correctamente");
            setState(prevState => {
                return {...prevState, entity: entityInit, loading: false};
            });
            props.onConfirm();
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }

    function AddCuentaDebitoCredito(item) {
        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/debito-credito`;
        const dataBody = {
            idCuenta: item.idCuenta,
            cuentaCorrienteItem: item
        };

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            dataBody,
            callbackSuccessAddCuentaDebitoCredito,
            callbackNoSuccess,
            callbackError
        );
    }


  return (

    <Modal
      size="lg"
      title="Ajuste débito/crédito"
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">
    
                <div className="mb-3 col-12">
                    <FormLabel htmlFor="detalle" required>Detalle</FormLabel>
                    <input
                        name="detalle"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('detalle') ? 'is-invalid' : ''}`}
                        value={ formValues.detalle }
                        onChange={ formHandle }
                    />
                    <FormError message={errorOf('detalle')} />
                </div>
                <div className="mb-3 col-12 col-md-6">
                    <FormLabel htmlFor="idTasa" required>Tasa</FormLabel>
                    <InputTasa
                        name="idTasa"
                        placeholder=""
                        className={`form-control ${errorOf('idTasa') ? 'is-invalid' : ''}`}
                        value={ formValues.idTasa }
                        onChange={ formHandle }
                    />
                    <FormError message={errorOf('idTasa')} />
                </div>
                <div className="mb-3 col-12 col-md-6">
                    <FormLabel htmlFor="idSubTasa" required>Sub tasa</FormLabel>
                    <InputSubTasa
                        name="idSubTasa"
                        placeholder=""
                        className={`form-control ${errorOf('idSubTasa') ? 'is-invalid' : ''}`}
                        value={ formValues.idSubTasa }
                        onChange={ formHandle }
                        idTasa={formValues.idTasa}
                    />
                    <FormError message={errorOf('idSubTasa')} />
                </div>
                {state.rubros && state.rubros.filter(idRubro => idRubro > 0).length > 0 &&
                <div className="mb-3 col-12">
                    <label htmlFor="idRubro" className="form-label">Rubro</label>
                    <InputEntidad
                        name="idRubro"
                        placeholder=""
                        className={`form-control ${errorOf('idRubro') ? 'is-invalid' : ''}`}
                        value={ formValues.idRubro }
                        onChange={ formHandle }
                        disabled={props.disabled}
                        title="Rubro"
                        entidad="Rubro"
                        filter={row => state.rubros.includes(row.id)}
                    />
                    <FormError message={errorOf('idRubro')} />
                </div>
                }
                <div className="mb-3 col-12 col-md-3">
                    <FormLabel htmlFor="imputacion" required>Tipo de ajuste</FormLabel>
                    <Select
                        name="imputacion"
                        className={`form-control ${errorOf('imputacion') ? 'is-invalid' : ''}`}
                        value={ formValues.imputacion }
                        onChange={ formHandle }
                        options={[
                            { value: 1, label: 'Debe' },
                            { value: 2, label: 'Haber' }
                        ]}
                    />
                    <FormError message={errorOf('imputacion')} />
                </div>
                <div className="mb-3 col-12 col-md-3">
                    <FormLabel htmlFor="importe" required>Importe</FormLabel>
                    <InputNumber
                        name="importe"
                        placeholder=""
                        className={`form-control ${errorOf('importe') ? 'is-invalid' : ''}`}
                        value={ formValues.importe }
                        precision={2}
                        onChange={ formHandle }
                    />
                    <FormError message={errorOf('importe')} />
                </div>

            </div>
      )}
      footer={(<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
                {canEditDebitoCredito &&
                <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
                }
      </>)}
    />

  );
}

CuentaDebitoCreditoModal.propTypes = {
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

export default CuentaDebitoCreditoModal;
